import API from 'services/api';

export const getBusinessYears = ({ id }: { id?: string }): Promise<number[]> =>
  API.get(`/api/accommodation/calculations/${id}/businessYears`)?.then(response => response?.data);
